module.exports = __webpack_public_path__ + "static/media/female-red-v3@2x.5d7a2bb8.png";